var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      fancy: _vm.fancy,
      items: _vm.matchedCountries,
      label: _vm.label,
      open: true,
      "select-on-tab": true,
      up: _vm.up,
      "empty-on-focus": "",
    },
    on: {
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      "item-click": function ($event) {
        return _vm.countrySelected($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _vm._v(" " + _vm._s(p.item.name)),
            _c("br"),
            _vm._v(" " + _vm._s(p.item.code) + " "),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }